import React, { useEffect, useState } from "react";
import Header from "../../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../../Components/Dashboard/Sidebar/Sidebar";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import recasimage from "../../../../Assets/Images/recasimage.png";
import "../RecasSceenshots/RecasSceenshots.css";
import Loader from "../../../../Components/loader/loader";
import { useLocation } from "react-router-dom";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import NewEmployeesModal from "../../../../Components/Modals/NewEmployeesModal";
import { RxCross2 } from "react-icons/rx";
import { GetToken } from "../../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { MdNavigateNext } from "react-icons/md";
import { GrFormPrevious } from "react-icons/gr";
import moment from "moment";

const RecasSceenshots = () => {
  const LoginToken = GetToken();
  const navigate = useNavigate();

  const location = useLocation();
  const screenCaptureData = location?.state?.data;

  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [allImages, setAllImages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [imagesPerPage, setImagesPerPage] = useState(9);

  const [allPagesNumber, setAllPagesNumber] = useState([]);

  const [totalCount, setTotalCount] = useState();
  const [imageId, setImageId] = useState();
  useEffect(() => {
    allImages?.map((item) => {
      setImageId(item?.ImageIds);
      return item;
    });
  }, [allImages]);


  const indexOfLastImage = currentPage * imagesPerPage;
  const indexOfFirstImage = indexOfLastImage - imagesPerPage;
  const currentImages = allImages.slice(indexOfFirstImage, indexOfLastImage);
  const handleImageClick = (item) => {
    // setAllImages(item?.Base64Image);
    setShowImageModal(true);
  };

  const [showModal, setShowModal] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [loading, setLoading] = useState(false);
  const [imagePageNumber, setImagePageNumber] = useState();
  const [selectImageId, setSelectImageId] = useState();
  // const [imageId, setImageId] = useState();

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);
  // useEffect(()=>{
  //   const pages=Math.ceil(totalCount/10);//7
  //   const arrNumber = Array.from({ length: pages }, (_, i) => i + 1);
  //   setAllPagesNumber(arrNumber)
  // },[totalCount])
const [selectedId,setSelectedId]=useState('')
  const handleSubmitScreenShot = (e, index) => {
    const data = {};
    if (e === "NumberClick") {
      const startIndex = index * 10;
      const endIndex = startIndex + 10;
      const selectedIds = selectImageId.slice(startIndex, endIndex);
      setSelectedId(selectedIds)
      data.pageNumber =  1;
      data.ImageIds = selectedIds;
    } else {
      setSelectImageId(e?.ImageIds);
      const arrayNum = e?.ImageIds;
      const pageValue = e?.ImageIds.length / 10;
      const maxNumber = Math.ceil(pageValue);
      const numbers = [];
      for (let i = 1; i <= maxNumber; i++) {
        numbers.push(i);
      }
      setAllPagesNumber(numbers);
      const pageNumber = 9;
      const result = arrayNum?.slice(0, pageNumber);
      data.pageNumber = 1;
      data.ImageIds = result;
    }
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `https://attendanceapi.elitewebdemo.com/api/Recas/GetImages`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const responceData = e?.data?.data;
        const verifyData = JSON.parse(responceData);
        setAllImages(verifyData);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          // navigate("/Adm/RecasScreenshot", { state: { data: verifyData } });
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    // handleSubmitScreenShot()
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <>
          <section
            className={
              showSidebar
                ? "dashboard-main-container"
                : "dashboard-main-container-new"
            }
          >
            <div className="all-icons">
              <div>
                <p className="DASHBOARD-MAIN-HEADING">Recas </p>
              </div>
              <div className="dashboiard-inner-header">
                <BiHomeAlt className="home-icon-header-inn" />
                <MdKeyboardArrowRight />
                <p>Recas </p>
                <MdKeyboardArrowRight />
                <p>Screenshot </p>
              </div>
            </div>
            <div>
              <div className="emp-dashboard-Leave-Requests-main-container">
                <div className="emp-dashboard-Leave-outter">
                  <div className="emp-dashboard-card-header">
                    <div>
                      <p className="Leave-heading">Recas</p>
                    </div>
                  </div>
                  <div className="table-for-tasks-overflow-data">
                    <table className="table-of-employee-leaves">
                      <thead className="thead-of-emp-table-leaves">
                        <tr className="">
                          <th className="hr-dashboard-no">Sr. No.</th>
                          <th className="hr-dashboard-Action">Task</th>
                          <th className="hr-dashboard-Action">Start Time</th>
                          <th className="hr-dashboard-Action">End Time</th>
                          <th className="hr-dashboard-Action">Action</th>
                        </tr>
                      </thead>

                      {screenCaptureData && screenCaptureData?.length > 0 ? (
                        <tbody className="tbody-ofemp-table-leaves">
                          {screenCaptureData
                            ?.sort((a, b) =>
                              a.Task?.Description.localeCompare(
                                b.Task?.Description
                              )
                            )
                            ?.map((item, index) => (
                              <tr key={index}>
                                <td> {index + 1}</td>
                                <OverlayTrigger
                                  placement="left"
                                  overlay={
                                    <Tooltip id="tooltip">
                                      {item?.Task?.Description}
                                    </Tooltip>
                                  }
                                >
                                  <td>
                                    {item?.Task?.Description?.length > 22
                                      ? `${item?.Task?.Description.slice(
                                          0,
                                          22
                                        )}..`
                                      : item?.Task?.Description}
                                  </td>
                                </OverlayTrigger>
                                <td>
                                  {/* {new Date(item?.StartTime).toLocaleDateString(
                                "en-US",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                }
                              )}
                              {new Date(item?.StartTime).toLocaleTimeString(
                                "en-US",
                                { hour: "2-digit", minute: "2-digit" }
                              )} */}

                                  {`${moment(item?.StartTime).format(
                                    "DD MMM YYYY"
                                  )} ${moment(item?.StartTime).format(
                                    "HH:mm"
                                  )}`}
                                </td>
                                <td>
                                  {/* {new Date(item?.EndTime).toLocaleDateString(
                                "en-US",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                } 
                              )}
                              {new Date(item?.EndTime).toLocaleTimeString(
                                "en-US",
                                { hour: "2-digit", minute: "2-digit" }
                              )} */}

                                  {`${moment(item?.EndTime).format(
                                    "DD MMM YYYY"
                                  )} ${moment(item?.EndTime).format("HH:mm")}`}
                                </td>
                                <td>
                                  <button
                                    className="screenshot-button"
                                    onClick={(e) => {
                                      setTotalCount(item?.ImageIdsCount);
                                      handleSubmitScreenShot(item);
                                    }}
                                  >
                                    Screenshots
                                  </button>
                                </td>
                                {/* <p>{item?.ImageIdsCount}</p> */}
                              </tr>
                            ))}
                        </tbody>
                      ) : (
                        // <div className="noDataFound">

                        <p>No data available</p>
                        // </div>
                      )}
                    </table>
                  </div>
                </div>
              </div>

              <div className="dashboard-allcards-flex-container-recas">
                {allImages?.map((item, index) => (
                  <div
                    className="dashboard-card-first-one-recas"
                    onClick={() => handleImageClick(item?.Base64Image)}
                    key={index}
                  >
                    <p className="recas-ScreenshotTime">
                      {moment(item?.ScreenshotTime).format("DD MMM YYYY HH:mm")}
                    </p>

                    <img src={item?.Base64Image} alt="" />
                  </div>
                ))}

                {/* <div
                  className="dashboard-card-first-one-recas"

                  onClick={() => handleImageClick(recasimage)}
                >
                  <img src={recasimage} alt="" />
                </div>
                <div className="dashboard-card-first-one-recas"
                  onClick={() => handleImageClick(recasimage)}
                >

                  <img src={allImages?.Base64Image} alt="" />
                </div>

                <div className="dashboard-card-first-one-recas">

                  <img src={recasimage} alt="" />
                </div>

                <div className="dashboard-card-first-one-recas">

                  <img src={recasimage} alt="" />
                </div> */}
              </div>
              {/* <GrFormPrevious  onClick={() => paginate(currentPage - 1)} />

             <MdNavigateNext  onClick={() => paginate(currentPage + 1)} /> */}
             <div  className="handelPage-Numbers">        
              {allPagesNumber?.map((item, index) => {
                return (
                    <div  className= {selectedId? "selectedIdscss" : "AllNumbers-design"}
                    onClick={() => handleSubmitScreenShot("NumberClick", index)}
                    >
                    {item}
                  </div>
                  );
              })}
                   </div>
            </div>
            <div className="emp-dashboard-cards"></div>
          </section>
        </>
      </div>
      {/* <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-in-employee-table"
      >
        <NewEmployeesModal className="modal-main-inner-container" />
      </Modal> */}

      {allImages?.map((item, index) => (
        <Modal
          show={showImageModal}
          onHide={() => setShowImageModal(false)}
          dialogClassName="modal-lg"
        >
          <Modal.Body className="model-body-container">
            <div>
              <div className="cross-icon-image-modal">
                <RxCross2 onClick={() => setShowImageModal(false)} />
              </div>
            </div>
            <img
              src={item?.Base64Image}
              alt="Full Screen"
              style={{ width: "100%", height: "80vh" }}
            />
          </Modal.Body>
        </Modal>
      ))}
    </>
  );
};
export default RecasSceenshots;
